// @flow

import * as Drip from '../../../utils/drip';
import type { DripParams } from '../../../utils/drip';

export default function trackEvent(event: string, params: DripParams = {}) {
  Drip.track(`Vortex Shaft Mount Calculator: ${event}`, params);
}





// WEBPACK FOOTER //
// ./src/views/tools/vortex/track-event.js